import {
	HDPI_Setting, Interaction_Setting, ISettingsHash, ISettingsService,
	LayerClassMode_Setting
} from "../services/settings";
import {L} from "../lt-ng/landcare-toolkit";
import is_high_density = L.is_high_density;
import is_touch_device = L.is_touch_device;


export interface ISettingsScope extends ng.IScope {
	hdpi: HDPI_Setting,
	hdpiOptions : HDPI_Setting[],
	setHdpi(hdpi : HDPI_Setting) : void;
	is_hdpi: boolean;

	interaction: Interaction_Setting
	interactionOptions : Interaction_Setting[]
	setInteraction(interaction : Interaction_Setting) : void;
	is_touch: boolean;

	initialLayerClassMode : LayerClassMode_Setting;
	layerClassMode: LayerClassMode_Setting;
	layerClassModeOptions : LayerClassMode_Setting[];
	setLayerClassMode(interaction : LayerClassMode_Setting) : void;
	is_combined: boolean;

	reloadPage(): void;

	defaultSettings : ISettingsHash;

	// shadingOptions : ReliefShading_Setting[];
	// shading: ReliefShading_Setting;
	// setShading(shading: ReliefShading_Setting);

	close() : void;
	// keyPress($event: KeyboardEvent, fn: Function, key: string);
	myKeyPress($event: KeyboardEvent, key: string, fn: Function, ...args: string[]);
}

export class SettingsCtrl {
	// noinspection JSUnusedLocalSymbols
	private static $inject = ['$scope', 'settingsService'];

	constructor(protected $scope: ISettingsScope, protected settingsService: ISettingsService) {
		$scope.defaultSettings = settingsService.defaultSettings();

		$scope.hdpiOptions = ['hdpi', 'standard'];

		$scope.hdpi = settingsService.getHdpi();
		$scope.is_hdpi = is_high_density();

		$scope.interactionOptions = ['mouse', 'touch'];
		$scope.interaction = settingsService.getInteractionMode();
		$scope.is_touch = is_touch_device();
		$scope.initialLayerClassMode = settingsService.getLayerClassMode();

		$scope.layerClassMode = settingsService.getLayerClassMode();
		$scope.layerClassModeOptions = ['combined', 'separate'];
		$scope.is_combined = is_touch_device();
		$scope.setLayerClassMode = (setting : LayerClassMode_Setting) =>
			settingsService.setLayerClassMode(setting);

		$scope.$on('settings:layerClassMode', (ev, newValue) => {
			$scope.layerClassMode = newValue;
		});

		$scope.$on('settings:hdpi', (ev : ng.IAngularEvent,
									 newValue : HDPI_Setting) => {
			$scope.hdpi = newValue;
		});

		$scope.myKeyPress = (event, key, fn, ...params) => {
			if (event.key === key) {
				fn.apply(this, params);
			}
		}
		$scope.setHdpi = (hdpi) => {
			settingsService.setHdpi(hdpi);
		};

		$scope.$on('settings:interaction', (ev : ng.IAngularEvent,
													newValue : Interaction_Setting) => {
			$scope.interaction = newValue;
		});

		$scope.setInteraction = (interaction) => {
			settingsService.setInteractionMode(interaction);
		};

		$scope.reloadPage = () => {
			console.log('SettingsCtrl: location.reload()')
			window.location.reload();
		};

		$scope.$on('modal.closing', () => {
			if ($scope.initialLayerClassMode != $scope.layerClassMode) {
				window.sessionStorage.setItem('hideLayerSelector', '1');
				console.log('SettingsCtrl: location.reload()')
				window.location.reload();
			}
		});

		/*$scope.$on('settings:reliefShading', (ev, newValue: ReliefShading_Setting) => {
			$scope.shading = newValue;
		});

		$scope.shading = settingsService.getReliefShading();
		$scope.shadingOptions = ['off', 'on'];
		$scope.setShading = (s) => settingsService.setReliefShading(s);*/
	}
}